'use client';

import { useTranslations } from '@/i18n/use-translations';
import type { BestsellerProduct } from './types';
import { isBestsellerProductUnavailable } from './bestsellerAvailability';
import styles from './RankingCard.module.css';

function normalizeSoldOutLabel(label: string): string {
  return label.replace(/<br\s*\/?>/gi, '\n');
}

export default function BestsellerSoldOutOverlay({
  descriptionId,
  product,
  platform,
}: {
  descriptionId: string;
  product: BestsellerProduct;
  platform: 'pc' | 'wap';
}) {
  const t = useTranslations('product');
  if (!isBestsellerProductUnavailable(product)) return null;

  const label = normalizeSoldOutLabel(
    t(product.status === 2 ? 'soldOut.noRestock' : 'soldOut.soldOut'),
  );

  return (
    <>
      <div
        className="pointer-events-none absolute inset-0 z-[1] flex items-center justify-center"
        data-bestseller-sold-out
        aria-hidden="true"
      >
        <span
          className={`flex aspect-square items-center justify-center rounded-full text-center font-bs font-semibold whitespace-pre-line text-white ${
            platform === 'pc'
              ? `${styles.soldOutCircle} bg-black/60`
              : 'size-[66px] bg-black/50 text-[11px] leading-[13px]'
          }`}
        >
          {label}
        </span>
      </div>
      <span id={descriptionId} className="sr-only">
        {label}
      </span>
    </>
  );
}
